//import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import React from "react";

import Login from './screens/Login';
import ReportsPage from './screens/ReportsPage';

// import ReactGA from 'react-ga';
// const TRACKING_ID = "G-0B0WC2C5YW"; // OUR_TRACKING_ID
// ReactGA.initialize(TRACKING_ID);
// ReactGA.pageview(window.location.pathname + window.location.search);


function App() {
  return (
    <Router>

    <Routes> 
      <Route exact path="/" element={<Login/>}/>
      <Route exact path="/ReportsPage" element={<ReportsPage/>} />
    </Routes>
</Router>
   
  );
}

export default App;


/* <input />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          //href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a> */

